<template>
  <span class="order-lock-wrap">
    <el-button type="info"
               size="mini"
               @click="lockOrder">
      <span v-show="locked">解锁审核</span>
      <span v-show="!locked">锁定审核</span>
    </el-button>

    <div v-if="locked" class="order-lock-reason-row">
      <span class="order-lock-reason-pill">
        <div class="order-lock-reason-pill__header">
          <i class="el-icon-lock"/>
          <span class="order-lock-reason-pill__label">锁单原因</span>
        </div>
        <div class="order-lock-reason-pill__body" v-text="lockReasonDisplayText"/>
      </span>
    </div>
  </span>
</template>

<script>
import QuestionReview from '@views/question-review/question-review.js'

export default {
  components: {},
  mixins: [],
  inject: ['page'],
  props: {
    id: [Number, String],
    locked: Boolean,
    lockReason: [String, null],
  },
  data () {
    return {}
  },
  computed: {
    lockReasonText () {
      return (this.lockReason || '').trim()
    },
    lockReasonDisplayText () {
      return this.lockReasonText || '<无锁单原因>'
    },
  },
  watch: {},
  beforeCreate () {},
  created () {},
  mounted () {},
  methods: {
    lockOrder () {
      // 解锁：保持原交互（不需要原因）
      if (this.locked) {
        return request.alert('lockOrder', {id: this.id}).then(() => {
          this.$message.success('订单审核已解锁')
          this.$store.commit('orderReview/LOCK_ORDER')
          this.$store.dispatch('setOrderDetail', {id: this.id})
        })
      }

      // 锁定：先保存答案缓存，再填写锁单原因（非必填）
      this.saveAnswer()
      return this.$prompt('锁单原因（可不填）', '锁定审核', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '例如：等待补充材料 / 异常数据核对中',
        inputType: 'textarea',
      }).then(({value}) => {
        return request.alert('lockOrder', {id: this.id, lock_reason: (value == null ? '' : String(value).trim())}).then(() => {
          this.$message.success('订单审核已锁定')
          this.$store.commit('orderReview/LOCK_ORDER')
          this.$store.dispatch('setOrderDetail', {id: this.id})
        })
      }).catch(() => {})
    },
    saveAnswer () {
      let answers = QuestionReview().getRecoveryAnswers(this.page)
      return request.common('saveOrderReviewCache', {
        id: this.id,
        templateresultjson: JSON.stringify(answers),
      })
    },
  },
}
</script>
<style lang="scss"
       scoped>
.order-lock-wrap {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
}

.order-lock-reason-row {
  margin-top: 6px;
  width: 100%;
}

.order-lock-reason-pill {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 6px 10px;
  line-height: 18px;
  border-radius: 14px;
  border: 1px solid #ebeef5;
  background: #f5f7fa;
  color: #606266;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
}

.order-lock-reason-pill__header {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  line-height: 18px;
}

.order-lock-reason-pill__label {
  color: #909399;
  flex: 0 0 auto;
  font-size: 12px;
}

.order-lock-reason-pill__body {
  margin-top: 4px;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 12px;
  line-height: 18px;
  text-indent: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/order-review/components/OrderLockButton.vue